module.exports = __webpack_public_path__ + "static/media/Search.fff2459a.svg";